export function buildShareUrl(platform, { text = '', mediaUrl = ''} = {}) {
  const safeText = text || '';
  const safeMedia = mediaUrl || '';
  if (platform === 'x') {
    const composed = `${safeText} ${safeMedia}`.trim();
    return `https://x.com/intent/post?text=${encodeURIComponent(composed)}`;
  }
  if (platform === 'facebook') {
    const u = safeMedia;
    const q = safeText.trim();
    const base = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`;
    return q ? `${base}&quote=${encodeURIComponent(q)}` : base;
  }
  return '';
}

export function openShare(platform, options) {
  const url = buildShareUrl(platform, options);
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
